import { createSlice } from "@reduxjs/toolkit";

export type Country = {
  id: number;
  code: string;
  name: string;
};

type InitialState = {
  data: Country[];
  departureData: Country[];
  arrivalData: Country[];
  isLoading: boolean;
  isLoadingDeparture: boolean;
  isLoadingArrival: boolean;
};

const initialState: InitialState = {
  data: [],
  departureData: [],
  arrivalData: [],
  isLoading: false,
  isLoadingDeparture: false,
  isLoadingArrival: false,
};

const countrySlice = createSlice({
  name: "countrySlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    fetchDepartureData: (state) => {
      state.isLoadingDeparture = true;
    },
    fetchArrivalData: (state, action) => {
      state.isLoadingArrival = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setDepartureData: (state, action) => {
      state.departureData = action.payload;
    },
    setArrivalData: (state, action) => {
      state.arrivalData = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsLoadingDeparture: (state, action) => {
      state.isLoadingDeparture = action.payload;
    },
    setIsLoadingArrival: (state, action) => {
      state.isLoadingArrival = action.payload;
    },
    reset: () => initialState,
  },
});

export default countrySlice;
